import { isValidYmd, safeParseYmd } from "../dateGuardrails";

export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseISODateYMD(ymd: unknown) {
  if (!ymd) return null;
  return safeParseYmd(String(ymd), "0001-01-01", "9999-12-31");
}

export function formatMD(ymd: unknown) {
  const dt = parseISODateYMD(ymd);
  if (!dt) return "";
  return `${dt.getMonth() + 1}/${dt.getDate()}`;
}

export function formatMDY(ymd: unknown) {
  const dt = parseISODateYMD(ymd);
  if (!dt) return "";
  return `${String(dt.getMonth() + 1).padStart(2, "0")}/${String(dt.getDate()).padStart(2, "0")}/${dt.getFullYear()}`;
}

export function addDaysYMD(ymd: unknown, days: number) {
  const dt = parseISODateYMD(ymd);
  if (!dt) return null;
  const d2 = new Date(dt);
  d2.setDate(d2.getDate() + days);
  return `${d2.getFullYear()}-${String(d2.getMonth() + 1).padStart(2, "0")}-${String(d2.getDate()).padStart(2, "0")}`;
}

export const isYmd = (date: string) => isValidYmd(date);
